import { AuthConsumer } from "./authProvider";

const SignInCallback = () => (
    <AuthConsumer>
        {({ signinRedirectCallback }) => {
            signinRedirectCallback();
            return <span>loading</span>;
        }}
    </AuthConsumer>
);

export default SignInCallback;
